import ExCircle from '../../../assets/icons/exCircle';
import * as css from './TicketRow.css';
import Ex from '../../../assets/icons/ex';
import CheckMark from '../../../assets/icons/checkMark';
import {useTranslation} from 'react-i18next';
import {VERY_DARK_GRAY} from '../../../globalVariables/GlobalVariables';
import SuccessCheckMark from '../../../assets/icons/successCheckMark';

type TicketRowProps = {
  title: string;
  description: string;
  price: number;
  selected: boolean;
  onClick: (action?: 'approve' | 'reject') => void;
};

export default function TicketRow({title, description, price, selected, onClick}: TicketRowProps) {
    const {t} = useTranslation('suspendedConfirmation');

    return (
        <css.ticketRowStyled $selected={selected} onClick={() => onClick(selected?'reject':'approve')}>
            {selected ? <SuccessCheckMark /> : <ExCircle />}
            <css.titleContainer>
                <css.title>{title}</css.title>
                <css.description>{description}</css.description>
            </css.titleContainer>
            <css.price>{`₪${price}`}</css.price>
            <css.buttonContainer>
                <css.approveButton $selected={selected} onClick={(e) => {
                    e.stopPropagation();
                    onClick('approve');
                }}>
                    <CheckMark color={VERY_DARK_GRAY} />
                    <span>{t('approveButton')}</span>
                </css.approveButton>
                <css.rejectButton $selected={selected} onClick={(e) => {
                    e.stopPropagation();
                    onClick('reject');
                }}>
                    <Ex color={VERY_DARK_GRAY} width={9} height={9} />
                    <span>{t('rejectButton')}</span>
                </css.rejectButton>
            </css.buttonContainer>
        </css.ticketRowStyled>
    );
}
